const roundToMonth = (months: number) => Math.round(months);

export default roundToMonth;
